import type { BloodGroup, Sex, VisitType } from '@/api/types'

/** The option lists three screens were each keeping their own copy of. */

export const SEX_OPTIONS: { value: Sex; label: string }[] = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'other', label: 'Other' },
]

/** "Not recorded" last: the real answers come first. The segmented control on
 *  the patient form omits it — a form offers three answers, but a record has to
 *  be able to hold none. */
export const SEX_SELECT_OPTIONS: { value: Sex; label: string }[] = [
  ...SEX_OPTIONS,
  { value: 'unknown', label: 'Not recorded' },
]

export const BLOOD_GROUPS: BloodGroup[] = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-']

export const BLOOD_GROUP_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'Not recorded' },
  ...BLOOD_GROUPS.map((group) => ({ value: group, label: group })),
]

export const VISIT_TYPE_OPTIONS: { value: VisitType; label: string }[] = [
  { value: 'consultation', label: 'Consultation' },
  { value: 'follow_up', label: 'Follow-up' },
  { value: 'review', label: 'Review' },
  { value: 'emergency', label: 'Emergency' },
]
